import { checkIntersection } from './check-intersection';
import { colinearPointWithinSegment } from './colinear-point-within-segment';
export { checkIntersection, colinearPointWithinSegment };